module.exports = __webpack_public_path__ + "assets/microsoft-word.9ba0b1f4.svg";